export const cmyk2rgb = ({
  c,
  m,
  y,
  k,
  normalized
}: {
  c: number
  m: number
  y: number
  k: number
  normalized?: boolean
}) => {
  c = c / 100
  m = m / 100
  y = y / 100
  k = k / 100

  c = c * (1 - k) + k
  m = m * (1 - k) + k
  y = y * (1 - k) + k

  let r = 1 - c
  let g = 1 - m
  let b = 1 - y

  if (!normalized) {
    r = Math.round(255 * r)
    g = Math.round(255 * g)
    b = Math.round(255 * b)
  }

  return {
    r: r,
    g: g,
    b: b
  }
}
